import React, { useMemo } from 'react';
import CustomReportsPanel from '../../../custom-reports/components/CustomReportsPanel';
import SessionQASection from '../../report/components/SessionQASection';
import { countWords } from '../utils/countWords';
import DetailsTab from './tabs/DetailsTab';
import InDepthTab from './tabs/InDepthTab';
import KnowledgeGraphTab from './tabs/KnowledgeGraphTab';
import ReportTab from './tabs/ReportTab';
import SpeakersTab from './tabs/SpeakersTab';
import TranscriptTab from './tabs/TranscriptTab';

/** Content of the active session tab. */
export default function SessionTabPanel({
  tab, sessionId, session, transcript, report, highlight, primaryLanguage,
  canGenerateReport, onGenerateReport, onCitationClick, onReportVersionChange, notify,
}) {
  const wordCount = useMemo(() => countWords(transcript.segments), [transcript.segments]);

  switch (tab) {
    case 'transcript':
      return (
        <TranscriptTab
          segments={transcript.segments}
          loading={transcript.loading}
          highlight={highlight}
          transcriptReferences={report.enrichment.transcriptReferences}
        />
      );
    case 'report':
      return (
        <CustomReportsPanel
          scope="session"
          scopeId={sessionId}
          title={session.title}
          eventTitle={session.event_title || ''}
          sessions={[session]}
          defaultSelectedIds={[sessionId]}
          missions={Boolean(session?.event_missions || session?.eventMissions)}
          sessionNumber={session?.session_number ?? session?.sessionNumber ?? null}
          officialLabel="Official report"
          onVersionChange={onReportVersionChange}
          onNotify={notify}
          onCitationClick={onCitationClick}
        >
          <ReportTab
            sessionId={sessionId}
            primaryLanguage={primaryLanguage}
            report={report}
            canGenerate={canGenerateReport}
            onGenerate={onGenerateReport}
            onCitationClick={onCitationClick}
          />
        </CustomReportsPanel>
      );
    case 'speakers':
      return <SpeakersTab report={report} onCitationClick={onCitationClick} />;
    case 'analysis':
      return <InDepthTab report={report} onCitationClick={onCitationClick} />;
    case 'qa':
      return (
        <SessionQASection
          questions={report.data?.questions || []}
          qaStatus={report.data?.qa_status || null}
          qaError={report.data?.qa_error || null}
          reportReady={report.exists}
          isSubmitting={report.isRegeneratingQa}
          onRegenerate={report.regenerateQa}
        />
      );
    case 'graph':
      return <KnowledgeGraphTab url={report.graphUrl} />;
    case 'details':
      return <DetailsTab session={session} reportStatus={report.status} wordCount={wordCount} notify={notify} />;
    default:
      return null;
  }
}
